<template>
    <div class="container-fluid p-0">
        <span v-if="!loading">
            <b-alert v-model="successAlertVisible" variant="success" dismissible>
                {{$t('saved_successful')}}
            </b-alert>

            <validation-observer ref="observer" v-slot="{ invalid, touched, errors, pristine }">
                <span v-if="errors !== formStateErrors"> {{setFormState('formStateErrors', errors)}}</span>
                <span v-if="formStatePristine !== pristine"> {{setFormState('formStatePristine', pristine)}}</span>
                <span v-if="formStateTouched !== touched"> {{setFormState('formStateTouched', touched)}}</span>
                <span v-if="formStateInvalid !== invalid"> {{setFormState('formStateInvalid', invalid)}}</span>

<!--                touched:{{touched}}-->
<!--                touchedFunc:{{formState.touched}}-->
<!--                invalidFunc:{{formState.invalid}}-->
<!--                formStateInvalid:{{formStateInvalid}}-->
<!--                <div v-bind:form="touched"></div>-->
<!--                passed:{{passed}}-->
<!--                pristine:{{pristine}}-->
<!--                formStatePristine:{{formStatePristine}}-->
<!--                errors:{{errors}}-->
<!--                invalid:{{invalid}}-->
<!--                submitAvailable:{{submitAvailable}}-->
                <b-form
                    @submit.prevent="onSubmit"
                    @reset="onReset"
                    v-if="show"
                >
                    <b-row class="ml-4" >
                        <b-button type="submit" :disabled="!submitAvailable" variant="primary" class="m-md-2">{{$t('save')}}</b-button>
                    </b-row>
                        <br>
                    <b-row v-for="row in rows" :key="row.id" class="container-fluid mb-3">
                        <b-col v-for="subSection in row" :key="subSection.id" cols="12" sm="6">
                            <b-card-header header-bg-variant="primary" header-text-variant="light" class="rounded">
                                {{subSection.name}}
                            </b-card-header>
                                <div v-for="field in subSection.fieldList" :key="field.name">
                                    <component
                                        :is="field.type"
                                        :field="field"
                                        :data.sync="formData[field.alias]"
                                    ></component>
                                </div>
                        </b-col>

                  </b-row>
            </b-form>
            </validation-observer>
        </span>
    </div>
</template>

<script>
    import TextInput from "./TextInput"
    import IntInput from "./IntInput"
    import SelectInput from "./SelectInput"
    import CheckboxInput from "./CheckboxInput"

    export default {
        name: "SettingsSection",
        components: {TextInput, IntInput, SelectInput, CheckboxInput},
        data: function() {
          return {
              loading: true,
              form: [],
              formData: {},
              show: true,
              cols: 2,
              formState: {
                  touched: false,
                  invalid: false
              },
              submitAvailable: false,
              formStateInvalid: false,
              formStatePristine: true,
              formStateTouched: false,
              formStateErrors: 0
          }
        },
        props: [
            "url",
            "section",
            "configuration",
            "deviceSettings",
            "changed",
            "showSuccessAlert"
        ],
        watch: {
            'configuration.sectionList': {
                handler() { this.setSubmitAvailable(); },
                deep: true
            },
            changed: function() {
                this.setSubmitAvailable();
            },
            formState: {
                handler(){
                    if (this.formState.touched) {
                        this.updateState();
                    }
                },
                deep: true
            },
            formStateInvalid: function() {
                this.updateState();
            },
            formStatePristine: function() {
                this.updateState();
            },
            formStateTouched: function() {
                this.updateState();
            },
            formStateErrors: function() {
                this.updateState();
            },

        },
        methods: {
            setSubmitAvailable() {
                this.submitAvailable = this.changed && !this.configuration.hasErrors();
            },
            updateState() {
                if (this.$refs.observer.flags.touched || this.$refs.observer.flags.pristine !== true) {
                    this.$emit('update:changed', 'true')
                    this.$emit('update:settings', this.formData)
                }

                let errors = 0;
                // console.log(this.$refs.observer.errors)
                for (let err in this.$refs.observer.errors) {
                    // console.log(this.$refs.observer.errors[err])
                    errors += this.$refs.observer.errors[err].length;
                }

                this.section.errors = errors;

                this.setSubmitAvailable();
            },
            setFormState(prop, value) {
                this[prop] = value;
            },
            onSubmit() {
                this.$refs.observer.validate().then((success) => {
                    if (success) {
                        this.$emit('save:settings')
                    }
                })
            },
            onReset(evt) {
                evt.preventDefault()
                // Reset our form values
                this.form.email = ''
                this.form.name = ''
                this.form.food = null
                this.form.checked = []
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                    this.show = true
                })
            }
        },
        computed: {
            successAlertVisible: {
                get() { return this.showSuccessAlert; },
                set(value) { this.$emit('update:showSuccessAlert', value); }
            },
            rows () {
                let result = []
                let rows = Math.ceil(this.form.length / this.cols)

                for (let row = 0; row < rows; row++) {
                    result.push(this.form.slice(row * this.cols, row * this.cols + this.cols))
                }

                return result;


            }
        },
        mounted() {
            let formData = {}

            this.setSubmitAvailable();

            this.section.subSectionList.forEach(
                subSection => {
                    let subSectionForm = [];
                    let subSectionFields = [];

                    subSection.settingViewAliasList.forEach(
                        settingViewAlias => {

                            const settingView = this.configuration.settingViewList[settingViewAlias];
                            const value = this.deviceSettings[settingViewAlias] !== undefined
                                ? this.deviceSettings[settingViewAlias]
                                : settingView.defaultValue;

                            let field = {
                                name: 's_' + settingViewAlias,
                                label: settingView.textBefore,
                                textAfter: settingView.textAfter,
                                placeholder: null,
                                alias: settingViewAlias,
                                readonly: settingView.readonly === true,
                                hint: settingView.hint,
                                rules: settingView.rules
                            };

                            switch (settingView.type) {
                                case "string":
                                    field.type = 'text-input'

                                    break;
                                case "int":
                                    field.type = 'int-input'
                                    break;
                                case "flag":
                                    field.type = 'checkbox-input'
                                    field.label = settingView.textAfter
                                    break;
                                case "dictionary":
                                    field.type = 'select-input'
                                    field.options = this.configuration.settingViewList[settingViewAlias].dictionary
                                    break;
                                default:
                                    field.type = 'text-input'
                                    break;
                            }

                            subSectionFields.push(field)

                            formData[settingViewAlias] = {
                                'value': value
                            }
                        }
                    )

                    this.form.push({
                        subSectionId: subSection.id,
                        name: subSection.name,
                        form: subSectionForm,
                        fieldList: subSectionFields
                    });

                    this.formData = formData;
                }
            )

            this.loading = false;
        }
    }
</script>

<style scoped>

</style>
